import React from 'react';

const DashboardContainer = ({ 
  children, 
  className = "",
  padding = "p-6",
  maxWidth = "max-w-7xl",
  blurIntensity = "backdrop-blur-lg",
  transparency = "bg-white/10",
  borderStyle = "border border-white/20"
}) => {
  return (
    <div className={`${maxWidth} mx-auto`}>
      <div className={`
        ${transparency}
        ${blurIntensity}
        rounded-2xl 
        shadow-2xl 
        ${borderStyle}
        ${padding} 
        ${className}
      `}>
        {children}
      </div>
    </div>
  );
};

export default DashboardContainer;